/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import Cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { MYACCOUNT_LOGO_MOBILE } from '../../config/constants/images';
import COOKIES from '../../config/cookies/cookies';
import { LINK_HOME } from '../../config/links/links';
import { APP_BANNER_TITLE } from '../../config/text/text';
import { getLocationShortName } from '../../helpers/location';
import ThemeContext from '../../providers/ThemeProvider';
import { getNavigation } from '../../redux/actions/navigation';
import HeaderItemsLayout from './HeaderItemsLayout';
import MyAccountMobileNavigation from './MyAccountMobileNavigation';
import HeaderNavigation from './navigation/HeaderNavigation';

const HeaderMobileMenu = ({ path }) => {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [location, navigation, ssr] = useSelector((state) => [
    state.locations.location,
    state.navigation.list || [],
    state.navigation.ssr,
  ]);
  const Environment = process.env.NEXT_PUBLIC_SITE || 'wowcher';

  useEffect(() => {
    const locationCookie = Cookies.load(COOKIES.location);
    const shortName = getLocationShortName(location);
    if (
      !locationCookie ||
      locationCookie === 'undefined' ||
      locationCookie.shortName === shortName
    ) {
      dispatch(getNavigation(location));
    }
  }, [dispatch, location]);

  return (
    <>
      <header className="header">
        <div className="header--desktop">
          <div className="items">
            <HeaderItemsLayout
              location={location}
              navigation={navigation}
              path={path}
            />
          </div>
          <HeaderNavigation
            location={location}
            navigation={navigation}
            path={path}
            site={process.env.NEXT_PUBLIC_SITE}
            ssr={ssr}
          />
        </div>
        <div className="header--mobile">
          <div className="header__container">
            <div className="header__item">
              <Link href={LINK_HOME}>
                <a className="header__link">
                  <img
                    alt={APP_BANNER_TITLE[Environment]}
                    className="img-fluid"
                    src={MYACCOUNT_LOGO_MOBILE[Environment]}
                  />
                </a>
              </Link>
            </div>
            <MyAccountMobileNavigation />
          </div>
        </div>
      </header>
      <style jsx>{`
        .items {
          background-color: ${theme.colors.headerbackground};
        }
        .header--mobile {
          display: none;
        }
        .header__container {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .header {
            padding: 5px 30px;
            position: relative;
            border-bottom: 1px solid #dbdbdb;
            background: ${theme.colors.primary};
          }
          .header--mobile {
            display: block;
          }
          .header--desktop {
            display: none;
          }
          .header__link {
            display: block;
            max-width: 30px;
            padding: 3px 0;
            outline: 0;
            line-height: 64px;
          }
        }
      `}</style>
    </>
  );
};

HeaderMobileMenu.propTypes = {
  path: PropTypes.string,
};

export default HeaderMobileMenu;
